<template>
    <div class="ring-container">
        <div class="ringring"></div>
        <div class="circle"></div>
        <div class="pulsating-text">{{ text }}</div>
    </div>
</template>

<script>
export default {
    name: 'PulsatingDot',
    props: {
        text: {
            type: String,
            default: '',
        },
    },
};
</script>

<style scoped>
@keyframes pulsate {
    0% {
        transform: scale(0.1, 0.1);
        opacity: 0;
    }
    50% {
        opacity: 1;
    }
    100% {
        transform: scale(1.2, 1.2);
        opacity: 0;
    }
}

.ring-container {
    position: absolute;
}

.circle {
    width: 7px;
    height: 7px;
    background-color: var(--primary);
    border-radius: 50%;
    position: absolute;
    top: 4px;
    left: 4px;
}

.ringring {
    border: 3px solid var(--primary);
    border-radius: 30px;
    height: 25px;
    width: 25px;
    position: absolute;
    left: -5px;
    top: -5px;
    animation: pulsate 1s ease-out;
    animation-iteration-count: infinite;
    opacity: 0;
}
.pulsating-text {
    text-align: left;
    margin-top: -1px;
    margin-left: 22px;
    font-size: 12px;
    color: black;
}
</style>
